/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceHighlight } from './EvidenceHighlight';
import {
  EvidenceHighlightFromJSON,
  EvidenceHighlightFromJSONTyped,
  EvidenceHighlightToJSON,
} from './EvidenceHighlight';

/**
 *
 * @export
 * @interface FindingWrite
 */
export interface FindingWrite {
  /**
   *
   * @type {number}
   * @memberof FindingWrite
   */
  riskIndicator: number;
  /**
   *
   * @type {string}
   * @memberof FindingWrite
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof FindingWrite
   */
  summary: string;
  /**
   *
   * @type {number}
   * @memberof FindingWrite
   */
  severity: number;
  /**
   *
   * @type {number}
   * @memberof FindingWrite
   */
  confidence?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof FindingWrite
   */
  explains?: Array<number>;
  /**
   *
   * @type {Array<object>}
   * @memberof FindingWrite
   */
  evidence?: Array<object>;
  /**
   *
   * @type {Array<EvidenceHighlight>}
   * @memberof FindingWrite
   */
  evidenceHighlights?: Array<EvidenceHighlight>;
  /**
   *
   * @type {boolean}
   * @memberof FindingWrite
   */
  reviewed?: boolean;
}

/**
 * Check if a given object implements the FindingWrite interface.
 */
export function instanceOfFindingWrite(value: object): value is FindingWrite {
  if (!('riskIndicator' in value) || value['riskIndicator'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  if (!('summary' in value) || value['summary'] === undefined) return false;
  if (!('severity' in value) || value['severity'] === undefined) return false;
  return true;
}

export function FindingWriteFromJSON(json: any): FindingWrite {
  return FindingWriteFromJSONTyped(json, false);
}

export function FindingWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingWrite {
  if (json == null) {
    return json;
  }
  return {
    riskIndicator: json['risk_indicator'],
    title: json['title'],
    summary: json['summary'],
    severity: json['severity'],
    confidence: json['confidence'] == null ? undefined : json['confidence'],
    explains: json['explains'] == null ? undefined : json['explains'],
    evidence: json['evidence'] == null ? undefined : json['evidence'],
    evidenceHighlights:
      json['evidence_highlights'] == null
        ? undefined
        : (json['evidence_highlights'] as Array<any>).map(EvidenceHighlightFromJSON),
    reviewed: json['reviewed'] == null ? undefined : json['reviewed'],
  };
}

export function FindingWriteToJSON(value?: FindingWrite | null): any {
  if (value == null) {
    return value;
  }
  return {
    risk_indicator: value['riskIndicator'],
    title: value['title'],
    summary: value['summary'],
    severity: value['severity'],
    confidence: value['confidence'],
    explains: value['explains'],
    evidence: value['evidence'],
    evidence_highlights:
      value['evidenceHighlights'] == null
        ? undefined
        : (value['evidenceHighlights'] as Array<any>).map(EvidenceHighlightToJSON),
    reviewed: value['reviewed'],
  };
}
